import { type } from 'os';
import React, { CSSProperties } from 'react';
import './index.less';

interface IProps {
  children: React.ReactElement | React.ReactElement[] | string
  className?: string
  onClick?: () => void
  type?: 'always' | 'none' | 'hover'
  highLight?: 'default' | 'red' | 'green'
  style?: CSSProperties | undefined
}

export default function SoilButton(props: IProps) {
    const {
        children,
        className,
        onClick,
        highLight,
        type,
        style
    } = props;

    let highLightClassName = '';

    if (type === 'always') {
        switch (highLight) {
            case 'red':
                highLightClassName = 'soil-red-color-always';
                break;
            case 'green':
                highLightClassName = 'soil-green-color-always';
                break;
            case 'default':
                highLightClassName = 'soil-default-color-always';
                break;
        }
    } else if (type === 'hover') {
        switch (highLight) {
            case 'red':
                highLightClassName = 'soil-red-color';
                break;
            case 'green':
                highLightClassName = 'soil-green-color';
                break;
            case 'default':
                highLightClassName = 'soil-default-color';
                break;
        }
    }

    return (
        <button style={style} className={`soil-button ${highLightClassName} ${className}`} onClick={() => onClick()}>
            {children}
        </button>
    );
}